export function relativeTime(value, locale = 'en') {
  const date = new Date(value);
  if (!value || !Number.isFinite(date.getTime())) return '—';
  const seconds = Math.min(0, Math.round((date.getTime() - Date.now()) / 1000));
  const [unit, divisor] = Math.abs(seconds) >= 86400 ? ['day', 86400] : Math.abs(seconds) >= 3600 ? ['hour', 3600] : Math.abs(seconds) >= 60 ? ['minute', 60] : ['second', 1];
  return new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(Math.round(seconds / divisor), unit);
}
export function dateTime(value, locale = 'en') {
  const date = new Date(value);
  return value && Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(date) : '—';
}
